/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingHomeIcon32Regular = forwardRef('BuildingHomeIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M12.464 6.45a5 5 0 0 1 7.071 0l9.758 9.757a1 1 0 0 0 1.414-1.414L20.95 5.036a7 7 0 0 0-9.9 0l-9.757 9.757a1 1 0 1 0 1.414 1.414l9.758-9.757Z" }),
        React.createElement("path", { d: "M8 17a1 1 0 1 0-2 0v6.5a5.5 5.5 0 0 0 5.5 5.5h9a5.5 5.5 0 0 0 5.5-5.5V17a1 1 0 1 0-2 0v6.5a3.5 3.5 0 0 1-3.5 3.5h-9A3.5 3.5 0 0 1 8 23.5V17Z" })));
});
